module.exports = __webpack_public_path__ + "static/cx-slider1-6c19673d121830004efff94538b35c57.jpeg";